export default "__VITE_PUBLIC_ASSET__63db1bc0__"